import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object().shape({
  inventory_asset_account: yup
    .string()
    .required("Inventory asset account mapping is required"),
  cost_of_goods_sold_account: yup
    .string()
    .required("Cost of goods sold account mapping is required"),
  stock_adjustment_lost_account: yup
    .string()
    .required("Stock adjustment/lost account mapping is required"),
});

const Validation = ({ inventoryAccountMapping }) => {
  return useForm({
    resolver: yupResolver(schema),
    shouldFocusError: true,
    mode: "onBlur",
    defaultValues: {
      ...inventoryAccountMapping,
    },
  });
};

export default Validation;
